import React, { useState } from 'react';
import styled from 'styled-components';
import back from '../../styles/assets/back_arrow.svg';

import { useNavigate } from "react-router-dom";
import { savePanNumber} from "../../services/backendHelpers";

const Container = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: flex-start; // Align content to the top
    height: 100vh;
    padding: 32px;
    background: linear-gradient(145deg, #0c0c1d, #1e1e2f);
`;

const BackTitle = styled.div`
    font-family: 'Poppins', sans-serif;
    font-weight: 600;
    font-size: 24px;
    color: #FFFFFF;
    cursor: pointer;
    display: flex;
    align-items: center;
`;

const SubTitle = styled.h2` // Changed from h1 to h2 for smaller size
    font-family: 'Poppins', sans-serif;
    font-weight: 400; // Less emphasis on subtitle
    font-size: 16px; // Reduced font size
    color: #FFFFFF;
    margin-top: 16px; // Reduced space from the back title
    margin-bottom: 24px; // Reduced space to input
`;

const Input = styled.input`
    width: calc(100% - 32px);
    padding: 16px;
    background: rgba(255, 255, 255, 0.05);
    border: 1px solid rgba(255, 255, 255, 0.2);
    border-radius: 12px;
    color: #FFFFFF;
    font-size: 18px;
    margin-bottom: 32px; // Adjusted space before the button
`;

const SaveButton = styled.button`
    padding: 16px;
    width: calc(100% - 32px);
    background-color: #10b981;
    color: white;
    border: none;
    border-radius: 12px;
    font-size: 18px;
    font-weight: 500;
    cursor: pointer;
    transition: background-color 0.3s, transform 0.2s;
    &:hover {
    background-color: #059669;
    transform: translateY(-2px);
    }
`;

const ErrorMessage = styled.span`
    color: #ff6b6b;
    font-size: 14px;
    margin-top: 4px;
    margin-bottom: 14px;
    display: block;
`;

const AddPanPage: React.FC<any> = (props: any) => {
    console.log('Props:', props);
    const navigate: any = useNavigate();
    const [pan, setPan] = useState('');
    const [error, setError] = useState('');


    const panRegex = /^[A-Z]{5}[0-9]{4}[A-Z]$/;
    
    const goBack = () => {
        navigate(-1);
    };

    const handleSave = async () => {
        // Check if the PAN is valid
        if (panRegex.test(pan)) {
            let rep = await savePanNumber({panNumber:pan});
            console.log('PAN save response:', rep);
            if(!rep){
                setError("Invalid pan");
                return;
            }
            await props.refetchStatus();
            console.log('PAN saved:', pan);
            // Add logic to handle saving the PAN number
            setError(''); // Clear any existing errors
        } else {
            setError('Invalid PAN format. Please enter a valid PAN number.');
        }
    };

    return (
        <Container>
          <BackTitle onClick={goBack}>
            <img src={back} alt="Go back" style={{ marginRight: '10px' }} />
            Add PAN
          </BackTitle>
          <SubTitle>Enter your PAN number</SubTitle>
          <Input
              type="text"
              value={pan}
              onChange={(e) => setPan(e.target.value)}
              placeholder="PAN Number"
          />
          {error && <ErrorMessage>{error}</ErrorMessage>}
          <SaveButton onClick={handleSave}>Save</SaveButton>
        </Container>
    );
};

export default AddPanPage;
